export const DeheadingPeelingColumns = [
    "SNo",
    "SCOPEOFWORK",
    "FOODTYPE",
    "VALUEADDITION1",
    "VALUEADDITION2",
    "GRADE",
    "RATEPERKG",
    "VALUEADDITION3",
    "RRPPRICE",

    // "MAXGRADE",
    // "MINGRADE"
]